import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../lib/utils';
import { Logo } from './Logo';
import { 
  LayoutDashboard, 
  Shield, 
  ScrollText, 
  Settings,
  ChevronLeft
} from 'lucide-react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import logoImage from '../assets/logo.png'; // Import logo dari assets

const navigation = [
  { name: 'Beranda', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Sertifikat', href: '/certificates', icon: Shield },
  { name: 'Log Aktivitas', href: '/logs', icon: ScrollText },
  { name: 'Pengaturan', href: '/settings', icon: Settings },
];

export function Sidebar({ collapsed, onToggle }) {
  return (
    <div
      className={cn(
        "flex flex-col h-full bg-card border-r transition-all duration-300",
        collapsed ? "w-16" : "w-64"
      )}
    >
      {/* Logo Header - UPDATED: Menggunakan Logo component */}
      <div className="flex items-center justify-between h-16 px-4 border-b">
        {!collapsed && (
          <div className="flex items-center gap-3">
            <Logo 
              src={logoImage}
              alt="Logo SSL Monitor"
              size="sm"
            />
            <span className="font-bold text-lg">Monitor SSL</span>
          </div>
        )}
        {collapsed && (
          <div className="mx-auto">
            <Logo 
              src={logoImage}
              alt="Logo SSL Monitor"
              size="sm"
            />
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                collapsed && "justify-center"
              )
            }
            title={collapsed ? item.name : undefined}
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            {!collapsed && <span>{item.name}</span>}
          </NavLink>
        ))}
      </nav>

      <Separator />

      {/* Toggle Button */}
      <div className="p-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggle}
          className="w-full justify-center"
        >
          <ChevronLeft
            className={cn(
              "h-4 w-4 transition-transform",
              collapsed && "rotate-180"
            )}
          />
        </Button>
      </div>
    </div>
  );
}